export const CRAVINGS = [
  { tag: "spicy", label: "🔥 SPICY" },
  { tag: "creamy", label: "🧈 CREAMY" },
  { tag: "smoky", label: "🪵 SMOKY" },
  { tag: "chicken", label: "🍗 CHICKEN" },
  { tag: "lamb-goat", label: "🥩 LAMB / GOAT" },
  { tag: "vegetarian", label: "🌱 VEGETARIAN" },
  { tag: "rice", label: "🍚 RICE" },
  { tag: "dhaba", label: "🥘 DHABA CLASSICS" },
  { tag: "street", label: "🌯 STREET FOOD" },
  { tag: "sweet", label: "🍬 SWEET" },
];

export const CravingChips = ({ selected = [], onToggle, testPrefix = "craving" }) => (
  <div className="flex gap-2 overflow-x-auto snap-x hide-scrollbar pb-1 flex-wrap">
    {CRAVINGS.map(({ tag, label }) => {
      const active = selected.includes(tag);
      return (
        <button
          key={tag}
          data-testid={`${testPrefix}-chip-${tag}`}
          onClick={() => onToggle(tag)}
          className={`shrink-0 snap-start rounded-full px-4 py-2.5 text-xs font-semibold tracking-wide border transition-colors ${
            active
              ? "bg-[#D4AF37] text-black border-[#D4AF37]"
              : "bg-[#1A1A1A] text-white/70 border-white/10 hover:border-[#D4AF37]/40"
          }`}
        >
          {label}
        </button>
      );
    })}
  </div>
);
